<template>
  <div>
    <ctlHomeNav />
    <v-container fluid>
      <ctlItemProductNav />
      <ctlHmRagWiki />
    </v-container>
  </div>
</template>

<script>
import ctlHomeNav from '@/components/ctlHomeNav'
import ctlHmRagWiki from '@/components/ctlHmRagWiki'
import ctlItemProductNav from '@/components/ctlItemProductNav'

export default {
  components: {
    ctlHomeNav,
    ctlHmRagWiki,
    ctlItemProductNav
  }
}
</script>
